import { render, staticRenderFns } from "./CFilesUpload.vue?vue&type=template&id=5fd4f454"
import script from "./CFilesUpload.vue?vue&type=script&lang=js"
export * from "./CFilesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports